import * as moment from "moment/moment";

export const create = {
    ROOT_URL: "employees/",
    fetchEmployeeType: false,

    addressTab: 0,
    languageDialog: false,
    mainTab: null,
    statuses: "O",
    panels: [0, 1, 2, 3, 4],
    sectionsExpanded: {
        basic: true,
        detail: false,
        address: false,
        education: false,
        awards: false,
        certificates: false,
        bank: false,
        log: true
    },
    certDialog: false,
    certEditIndex: -1,
    certForm: {
        id: null,
        type: '',
        title: '',
        attachmentUrl: ''
    },
    isValid: false,
    departmentSearch: null,
    departments: [],
    employeeSearch: null,
    employees: [],
    marriages: [
        { text: "Kết hôn", value: "KH" },
        { text: "Độc thân", value: "DT" },
        { text: "Chưa có thông tin", value: "" },
    ],
    pharmaCerts: [
        { text: "Không có", value: "KHONG" },
        { text: "Đại học", value: "DH" },
        { text: "Cao đẳng", value: "CD" },
    ],
    dCities: [],
    dDistricts: [],
    cities: [],
    districts: [],
    wards: [],
    dWards: [],

    altCities: [],
    altWards1: [],
    altWards2: [],

    educationLevels: [],
    universities: [],
    academicRanks: [],
    educationMajors: [],
    educationStatues: [
        { text: "Tốt nghiệp", value: true },
        { text: "Chưa tốt nghiệp", value: false },
    ],
    ethnicities: [],
    religions: [],
    origins: [],
    banks: [],
    areas: [],

    benefitMans: [],
    benefitManHeaders: [
        { text: 'Loại', value: 'type' },
        { text: 'Từ ngày', value: 'from' },
        { text: 'Đến ngày', value: 'to' },
        { text: 'Ngày xác định', value: 'strDates' },
        { text: 'Tạo vào', value: 'createdAt' },
    ],

    leaveEnrollments: [],
    leaveEnrollmentHeaders: [
        { text: 'Loại phép', value: 'leaveName' },
        { text: 'Từ ngày', value: 'validFrom' },
        { text: 'Đến ngày', value: 'validTo' },
        { text: 'Giới hạn phép', value: 'hasAmount' },
        { text: 'Số phép', value: 'amount' }
    ],

    genders: [
        { text: "Nam", value: true },
        { text: "Nữ", value: false },
    ],
    globalIsVerified: false,

    idPlaceAuth: null,
    idPlaceLoc: null,
    statusText: "",
    isLoading: false,
    form: {
        status: 1,
        avatar: '',
        //tab1
        name: '',
        gender: null,
        birthDay: moment().format("YYYY-MM-DD"),
        phoneNumber: '',
        mail: '',
        hireDate: moment().format("YYYY-MM-DD"),
        isVerified: false,
        // tab2
        idNumber: '',
        idDate: moment("1975-04-30").format("YYYY-MM-DD"),
        idPlace: '',
        marriage: '',
        bankCode: '',
        bankNumber: '',
        bank2Code: '',
        bank2Number: '',
        ethnicityCode: null,
        religionCode: null,
        originCode: null,
        domicileCityCode: null,
        domicileDistrictCode: null,
        domicileWardCode: null,
        domicileAddress: null,
        cityCode: null,
        districtCode: null,
        wardCode: null,
        address: "",

        // tab3
        educationLevelCode: null,
        universityCode: null,
        academicRankCode: null,
        educationMajorCode: null,
        educationStatus: true,
        eduDateFrom1: null,
        eduDateTo1: null,
        eduRating1: null,

        university2Code: null,
        academicRank2Code: null,
        educationMajor2Code: null,
        educationStatus2: true,
        eduDateFrom2: null,
        eduDateTo2: null,
        eduRating2: null,
        languages: [],
        languageCerts: '',

        departmentTypeName: "",
        departmentName: "",
        teamName: "",
        positionName: "",
        positionStateName: "",
        shiftName: "",

        //tab4
        areaCode: null,
        bfoAccount: "",
        attachmentLink: "",
        employeeType: '',

        //tab5
        isQuit: false,
        isSuspend: false,
        isPregnant: false,
        notAccept: false,
        quitDate: moment("2100-01-01").format("YYYY-MM-DD"),
        endQuitDate: moment("2100-01-01").format("YYYY-MM-DD"),
        quitNote: "",
        employeeReturn: "",

        idFrontImageUrl: '',
        idBackImageUrl: '',
        bankImageUrl: '',
        maritalImageUrl: '',
        religionImageUrl: '',
        insuranceNumber: '',
        healthInsuranceNumber: '',
        taxNumber: '',

        newCityId: null,
        newWardId: null,
        newCityId2: null,
        newWardId2: null,

        applicationUrl: '',
        resumeUrl: '',
        residenceUrl: '',
        healthCertUrl: '',
        educationCert1Url: '',
        educationCert2Url: '',
        educationCert3Url: '',
        educationCert4Url: '',
        educationCert5Url: '',
        awards: [],
        employeeCertificates: [],
        // managerList: [],
    },
    defaultForm: {
        status: 1,
        avatar: '',
        //tab1
        name: '',
        gender: null,
        birthDay: moment().format("YYYY-MM-DD"),
        phoneNumber: '',
        mail: '',
        hireDate: moment().format("YYYY-MM-DD"),
        isVerified: false,
        // tab2
        idNumber: '',
        idDate: moment("2100-01-01").format("YYYY-MM-DD"),
        idPlace: '',
        marriage: '',
        bankCode: '',
        bankNumber: '',
        bank2Code: '',
        bank2Number: '',
        ethnicityCode: null,
        religionCode: null,
        originCode: null,
        domicileCityCode: null,
        domicileDistrictCode: null,
        domicileWardCode: null,
        domicileAddress: null,
        cityCode: null,
        districtCode: null,
        wardCode: null,
        address: "",
        seniority: "",
        originSeniority: "",

        // tab3
        educationLevelCode: null,
        universityCode: null,
        academicRankCode: null,
        educationMajorCode: null,
        educationStatus: true,
        eduDateFrom1: null,
        eduDateTo1: null,
        eduRating1: null,
        university2Code: null,
        academicRank2Code: null,
        educationMajor2Code: null,
        educationStatus2: true,
        eduDateFrom2: null,
        eduDateTo2: null,
        eduRating2: null,
        languages: [],
        languageCerts: '',

        departmentTypeName: "",
        departmentName: "",
        positionName: "",
        positionStateName: "",
        shiftName: "",
        teamName: "",

        //tab4
        areaCode: null,
        bfoAccount: "",
        attachmentLink: "",
        employeeType: '',

        //tab5
        isQuit: false,
        isSuspend: false,
        isPregnant: false,
        notAccept: false,
        quitDate: moment("2100-01-01").format("YYYY-MM-DD"),
        endQuitDate: moment("2100-01-01").format("YYYY-MM-DD"),
        quitNote: "",
        employeeReturn: "",

        idFrontImageUrl: '',
        idBackImageUrl: '',
        bankImageUrl: '',
        maritalImageUrl: '',
        religionImageUrl: '',
        insuranceNumber: '',
        healthInsuranceNumber: '',
        taxNumber: '',

        newCityId: null,
        newWardId: null,
        newCityId2: null,
        newWardId2: null,
        applicationUrl: '',
        resumeUrl: '',
        residenceUrl: '',
        healthCertUrl: '',
        educationCert1Url: '',
        educationCert2Url: '',
        educationCert3Url: '',
        educationCert4Url: '',
        educationCert5Url: '',
        awards: [],
        employeeCertificates: [],
        // managerList: [],
    },

    //assignment Dialog
    assignmentDialog: false,
    workHistoryDialog: false,
    leaveEnrollHistoryDialog: false,
    leaveEnrollDialog: false,
    createContractDialog: false,
    createUserDialog: false,

    listContractDialog: false,
    employee: null,
    statusHistory: [],
    statusHistoryHeaders: [
        { text: 'Mã', value: 'code', width: "5rem" },
        { text: 'Trạng thái', value: 'status', width: "5rem" },
        { text: 'Ngày nghỉ', value: 'date', width: "5rem" },
        { text: 'Ngày bắt đầu làm lại', value: 'endDate', width: "7rem" },
        { text: '', value: 'actions', width: "auto" },
    ],

    updateStatusHistoryDialog: false,
    deleteStatusHistoryDialog: false,
    UpdateStatusHistoryObj: {
        code: "",
        status: 0,
        date: null,
        endDate: null,
    },
    DeleteStatusHistoryObj: {},
    LOCK: true,

    statusAction: [],
    statusActionHeaders: [
        { text: 'Mã NV', value: 'updatedBy', width: "7rem" },
        { text: 'Thời gian', value: 'updatedAt', width: "7rem" },
        { text: 'Thao tác', value: 'action', width: "7rem" },
    ],

    detailTab: 0,
    detailItems: ["Trạng thái làm việc", "Vị trí/ca/cột", "Điều chuyển", "Phân loại nhân viên"],

    statusTableHeaders: [
        { text: '', value: 'actions', sortable: false, width: "60px" },
        // { text: 'Mã', value: 'code', sortable: false, width: "4rem"},
        { text: 'NGUỒN', value: 'source', sortable: false, width: "100px" },
        { text: 'TRẠNG THÁI', value: 'status', sortable: false, width: "200px" },
        { text: 'THỜI GIAN', value: 'fromDate', sortable: false, width: "250px" },
        // { text: 'Đến ngày', value: 'toDate', sortable: false, width: "10rem"},
        { text: 'TẠO', value: 'createdAt', sortable: false, width: "120px" },
        // { text: 'Tạo bởi', value: 'createdBy', sortable: false, width: "5rem"},
        { text: 'CẬP NHẬT', value: 'updatedAt', sortable: false, width: "120px" },
        // { text: 'Sửa bởi', value: 'updatedBy', sortable: false, width: "auto"},
        { text: 'GHI CHÚ', value: 'note', sortable: false, width: "auto" },
    ],
    statusTableItems: [
    ],
    statusEdit: "",
    statusType: [
        { text: "Hoạt động", value: 1 },
        { text: "Tạm nghỉ", value: 2 },
        { text: "Thai sản", value: 3 },
        { text: "Nghỉ việc", value: 4 },
        { text: "Không nhận việc", value: 6 }
    ],
    addStatus: false,

    employeeStatusDetailLoading: false,
    employeeStatusDetailForm: {
        status: 1,
        fromDate: null,
        toDate: null,
        note: null
    },

    employeeStatusDetailEditForm: {
        status: 1,
        fromDate: null,
        toDate: null,
        note: ''
    },
    employeeStatusDetailEditFormValid: false,
    deleteStatusDetailCfm: false,

    //section promotion
    promoteTableHeaders: [
        { text: '', value: 'actions', sortable: false, width: "40px" },
        { text: 'Nguồn & Mã', value: 'sourceInfo', sortable: false, width: "120px" },
        { text: 'Công việc', value: 'jobInfo', sortable: false, width: "240px" },
        { text: 'Từ - Đến', value: 'timeRange', sortable: false, width: "160px" },
        { text: 'Tạo bởi', value: 'createdAt', sortable: false, width: "140px" },
        { text: 'Sửa bởi', value: 'updatedAt', sortable: false, width: "140px" },
        { text: 'Ghi chú', value: 'note', sortable: false, minWidth: "150px" }
    ],
    promoteTableItems: [
    ],
    promoteEdit: "",
    promoteAdd: false,

    employeePromoteDetailLoading: false,
    promoteDetailData: {
        positions: [],
        positionStates: [],
        shifts: []
    },
    employeePromoteDetailForm: {
        positionCode: "",
        positionStateCode: "",
        shiftCode: "",
        fromDate: null,
        toDate: null,
        note: ""
    },

    employeePromoteDetailEditForm: {
        positionCode: "",
        positionStateCode: "",
        shiftCode: "",
        fromDate: null,
        toDate: null,
        note: ""
    },
    employeePromoteDetailEditFormValid: false,
    deletePromoteDetailCfm: false,

    //section rotataion
    rotationLoading: false,
    departmentTypes: [],
    teams: [],
    divisions: [],
    teams2: [],
    units: [],

    rotationTableHeaders: [
        { text: '', value: 'actions', sortable: false, width: "40px" },
        { text: 'Mã CT', value: 'id', sortable: false, width: "80px" },
        { text: 'Khối', value: 'departmentTypeName', sortable: false, width: "120px" },
        { text: 'Phòng / Team', value: 'orgInfo', sortable: false, width: "200px" },
        { text: 'Từ - Đến', value: 'timeRange', sortable: false, width: "120px" },
        { text: 'Tạo bởi', value: 'createdAt', sortable: false, width: "130px" },
        { text: 'Cập nhật', value: 'updatedAt', sortable: false, width: "130px" },
        { text: 'Ghi chú', value: 'note', sortable: false, minWidth: "150px" },
    ],
    rotationTableItems: [
    ],
    rotationEdit: "",
    rotationAdd: false,
    rotationUpdate: false,

    employeeRotationDetailLoading: false,
    rotationDetailData: {
        positions: [],
        positionStates: [],
        shifts: []
    },
    employeeRotationDetailForm: {
        id: "",
        departmentTypeCode: "",
        departmentCode: "",
        teamCode: "",
        divisionCode: "",
        team2Code: "",
        unitCode: "",
        rotationDateFrom: "",
        rotationDateTo: ""
    },

    employeeRotationDetailEditForm: {
        code: "",
        departmentTypeCode: "",
        departmentCode: "",
        teamCode: "",
        divisionCode: "",
        team2Code: "",
        unitCode: "",
        rotationDateFrom: "",
        rotationDateTo: ""
    },
    employeeRotationDetailEditFormValid: false,
    deleteRotationDetailCfm: false,

    dateValidRules: [
        v => !!v || 'Bạn nhập dữ liệu này',
        v => moment(v, 'DD/MM/YYYY', true).isValid() || 'Định dạng ngày không đúng',
    ],
    families: [],
    familyHeaders: [
        // {text:'Tên nhân viên',  value: 'employeeName'},
        { text: 'Mối quan hệ', value: 'relationType' },
        { text: 'Tên người thân', value: 'memberName' },
        { text: 'SĐT', value: 'phoneNumber' },
        // {text:'Ngày sinh',  value: 'doB'},
    ],
}